<template>
  <v-container v-if="!loading">
    <v-row v-if="profile" wrap>
      <v-col cols="6" class="py-0">
        <DisplayField label="Name" :value="name" />
      </v-col>
      <v-col cols="6" class="py-0">
        <DisplayField label="Title" :value="profile.title" />
      </v-col>
      <v-col cols="6" class="py-1">
        <DisplayField label="Preferred Name" :value="profile.nickName" />
      </v-col>
      <v-col cols="6" class="py-1">
        <DisplayField label="Suffix" :value="profile.suffix" />
      </v-col>
      <v-col cols="6" class="py-1">
        <DisplayField label="D.O.B." :value="profile.dateOfBirth" type="piiDate" />
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12" md="3">
        Profile not found
      </v-col>
    </v-row>
    <ProfileContacts />
  </v-container>
</template>

<style>
</style>

<script>
import { mapState, mapActions } from 'vuex';
import ProfileContacts from '@/components/Client/Profiles/ProfileContacts.vue';
import DisplayField from '@/components/Shared/DisplayField.vue';

export default {
  name: 'PersonalProfileDetail',
  components: {
    ProfileContacts,
    DisplayField
  },
  data: function () {
    return {
      profile: null,
      loading: true,
      style: {
        'background-color': this.$vuetify.theme.themes.light.blue4,
        'border-radius': '5px'
      }
    };
  },
  computed: {
    ...mapState(['selectedProfileId']),
    clientId: function () {
      return this.$route.params.clientId;
    },
    profileId: function () {
      return this.selectedProfileId;
    },
    name: function () {
      var n = this.profile.firstName;
      if ((this.profile.middleName || null) !== null) {
        n += ` ${this.profile.middleName}`;
      }

      if ((this.profile.lastName || null) !== null) {
        n += ` ${this.profile.lastName}`;
      }

      return n;
    }
  },
  watch: {
    profileId: async function (val) {
      if (val != null && val > 0) {
        await this.getProfile();
      }
    }
  },
  mounted: async function () {
    await this.getProfile();
  },
  methods: {
    ...mapActions(['setError', 'getProfileDetails']),
    getProfile: async function () {
      this.loading = true;

      this.profile = await this.getProfileDetails({
        clientId: this.clientId,
        profileId: this.profileId
      });

      this.loading = false;
    }
  }
};
</script>
